import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWifiNoSignal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWifiNoSignal"><Path d="M12 19.25H12.01M12.25 19.25C12.25 19.3881 12.1381 19.5 12 19.5C11.8619 19.5 11.75 19.3881 11.75 19.25C11.75 19.1119 11.8619 19 12 19C12.1381 19 12.25 19.1119 12.25 19.25Z" stroke="currentColor" strokeLinecap="round"/><Path d="M15.3281 14.3281L8.67127 7.67127" stroke="currentColor" strokeLinecap="square"/><Path d="M8.67188 14.3286L15.3287 7.67176" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWifiNoSignal;
